import { REPORTS_TYPES } from 'constants/report';
import callAPiBase from './base';

const fleetApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/carList',
      method: 'GET',
      useToken: true,
      title: 'Car - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/carCreate',
      method: 'POST',
      useToken: true,
      title: 'Car - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/carUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Car - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/carDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Car - Delete',
      params,
    }),
  report: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.CAR_ENTRY}`,
      method: 'GET',
      useToken: true,
      title: 'Car - Report List',
      params,
    }),
  reportQuantity: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.CAR_QUANTITY}`,
      method: 'GET',
      useToken: true,
      title: 'Car - Report Quantity List',
      params,
    }),
  carSettingsGet: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/carSettingsGet',
      method: 'GET',
      useToken: true,
      title: 'Car - Get List',
      params,
    }),

  carSettingsUpdate: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/carSettingsUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Car - Update',
      data,
    }),
};

export { fleetApi };
export default fleetApi;
